import { TEmployeeRole, TNeedleActionPermissions, TNeedleDetails, TRESPONSE_NEEDLE_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import _ from 'lodash';
import { TTableTreeModel } from '../../table.type';

function _getLocationDisplayStr(localInventory: TRESPONSE_NEEDLE_LIST['needles'][number]['localStoreDetails'][number]) {
  switch (localInventory.location.locationType) {
    case 'FLOOR_NEEDLE_STORE': {
      return `Floor ${localInventory.location.floor}`;
    }
    case 'SECTION_NEEDLE_STORE': {
      return `Section ${localInventory.location.section}`;
    }
    default:
      return '';
  }
}

export const NEEDLE_LIST_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_NEEDLE_LIST['needles'],
    selectedNeedles: TRESPONSE_NEEDLE_LIST['needles'],
    needleActionPermissions?: TNeedleActionPermissions,
    employeeRole?: TEmployeeRole[number] | undefined,
  ) => {
    const isAdminLikeUser = !!items[0]?.mainStoreDetailsOpt;
    //TODO[Ramya][somnath]: check if showLocalInventoryHeader should rely on mainInventoryOpt
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select:
          needleActionPermissions?.canRaiseRequest || needleActionPermissions?.canEditNeedle
            ? { position: 'START', isMulti: true, size: 'DEFAULT' }
            : undefined,
        headerConfig: _.compact([
          employeeRole === 'FACTORY_GROUP_ADMIN'
            ? {
                type: 'TEXT_CELL',
                text: 'FACTORY ID',
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.NEEDLETYPE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.NEEDLEPOINT',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.SIZE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.COATING',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.BRAND',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.NEEDLENUMBER',
          },
          isAdminLikeUser
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.MAINSTOREQUANTITY',
              }
            : {
                type: 'TEXT_CELL',
                text: 'table_model.LOCALINVENTORY',
              },
          {
            type: 'TEXT_CELL',
            text: 'table_model.IN-USEQUANTITY',
          },
          { type: 'TEXT_CELL' as const, text: '', widthInPx: 32 },
          ...(needleActionPermissions?.canEditNeedle ? [{ type: 'TEXT_CELL' as const, text: '', widthInPx: 32 }] : []),
        ]),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          rowSelectionInfo: {
            isSelected: selectedNeedles.some((needle) => needle.needleId === item.needleId),
            isDisabled: false,
          },
          cells: _.compact([
            employeeRole === 'FACTORY_GROUP_ADMIN'
              ? {
                  type: 'TEXT_CELL',
                  text: item.factoryId,
                }
              : undefined,
            {
              type: 'TEXT_CELL',
              text: item.needleType,
            },
            {
              type: 'TEXT_CELL',
              text: item.point,
            },
            {
              type: 'TEXT_CELL',
              text: item.size,
            },
            {
              type: 'TEXT_CELL',
              text: item.coating || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.brand,
            },
            {
              type: 'TEXT_CELL',
              text: item.needleNumber,
            },
            item.mainStoreDetailsOpt
              ? {
                  type: 'TEXT_CELL',
                  text: item.mainStoreDetailsOpt.quantity,
                }
              : item.localStoreDetails.length
              ? {
                  type: 'TEXT_LIST_CELL',
                  text: [_getLocationDisplayStr(item.localStoreDetails[0]), item.localStoreDetails[0].quantity],
                }
              : {
                  type: 'TEXT_CELL',
                  text: '--',
                },
            {
              type: 'TEXT_CELL',
              text: item.inUseQuantity,
            },
            (isAdminLikeUser ? item.localStoreDetails.length > 0 : item.localStoreDetails.length > 1)
              ? {
                  type: 'ACTION_CELL',
                  actionType: 'VIEW',
                  asIcon: true,
                }
              : {
                  type: 'TEXT_CELL',
                  text: '',
                },
            ...(needleActionPermissions?.canEditNeedle
              ? [{ type: 'ACTION_CELL' as const, actionType: 'EDIT' as const, asIcon: true }]
              : []),
          ]),
        };
      },
    );
  },

  deselectAllRows: (tableModel: TTableTreeModel<TNeedleDetails>): TTableTreeModel<TNeedleDetails> => {
    return ModifiersZTableModel.deselectAllRows(tableModel);
  },
};
